<template>
  <div class="env-impact-summary">
    <div v-if="loading" class="text-gray-500">집계 중...</div>
    <template v-else>
      <div v-if="!field" class="flex flex-wrap gap-6">
        <div>
          <span class="font-bold mr-2">총 등록건수:</span><span>{{ totalCount }}건</span>
        </div>
        <div v-for="fieldName in fieldOrder" :key="fieldName">
          <span class="font-bold mr-2">{{ fieldName }}:</span><span>{{ fieldCounts[fieldName] || 0 }}건</span>
        </div>
      </div>
      <div v-else class="flex flex-wrap gap-6">
        <div>
          <span class="font-bold mr-2">등록건수:</span><span>{{ totalCount }}건</span>
        </div>
        <div>
          <span class="font-bold mr-2">승인됨:</span><span>{{ statusCounts.approved }}건</span>
        </div>
        <div>
          <span class="font-bold mr-2">진행 중:</span><span>{{ statusCounts.ongoing }}건</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
const FIELD_NAME_KEY = "body.stdInfo.field_name";

const STATUS_ID = {
  APPROVED: [4],
  ONGOING: [2, 3],
};

export default {
  name: "Board899Summary",
  props: {
    boardId: { type: [Number, String], required: true },
    nav: { type: Object, default: () => ({}) },
    projectId: { type: [Number, String], default: null },
    refreshKey: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      totalCount: 0,
      fieldCounts: {},
      statusCounts: { approved: 0, ongoing: 0 },
      fieldOrder: ["본사", "인천공장", "당진공장", "포항공장", "중앙기술연구소"],
    };
  },
  computed: {
    field() {
      return this.$route.query.fd || "";
    },
    yearRange() {
      const v = (this.nav && this.nav.value) || {};
      if (v.yearRange && (v.yearRange.start || v.yearRange.end)) {
        return v.yearRange;
      }
      const currentYear = new Date().getFullYear();
      return { start: currentYear - 2, end: currentYear };
    },
    resolvedProjectId() {
      if (this.projectId) return this.projectId;
      return this.$route.params.proj_id;
    },
  },
  watch: {
    refreshKey() {
      this.loadSummary();
    },
  },
  methods: {
    buildConditions() {
      const conditions = [];
      const yr = this.yearRange;
      if (yr && yr.start) {
        conditions.push({ key: "created_at", operator: ">=", value: `${yr.start}-01-01` });
      }
      if (yr && yr.end) {
        conditions.push({ key: "created_at", operator: "<", value: `${Number(yr.end) + 1}-01-01` });
      }
      if (this.field) {
        conditions.push({ key: FIELD_NAME_KEY, operator: "=", value: this.field });
      }
      return conditions;
    },

    getBody(item) {
      if (item && item.postContents && item.postContents.body) return item.postContents.body;
      if (item && item.post_contents && item.post_contents.body) return item.post_contents.body;
      return null;
    },

    getFieldName(item) {
      const body = this.getBody(item);
      if (body && body.stdInfo && body.stdInfo.field_name) return body.stdInfo.field_name;
      return null;
    },

    async loadSummary() {
      this.loading = true;
      try {
        const conditions = this.buildConditions();
        const response = await this.$store.dispatch("approval/LOAD_POST_ALL", {
          boardSlug: `board-${this.boardId}`,
          projectId: this.resolvedProjectId,
          page: 1,
          perPage: 9999,
          orderTarget: "created_at",
          orderDirection: "desc",
          conditions,
          statusIds: [2, 3, 4],
          metaKeys: [FIELD_NAME_KEY],
          withMeta: true,
          onlyMeta: true,
          withoutRelation: true,
          isParent: false,
        });

        const data = (response && response.data) || [];
        const fieldCounts = {};
        const statusCounts = { approved: 0, ongoing: 0 };

        for (const item of data) {
          const fieldName = this.getFieldName(item);
          if (fieldName) {
            fieldCounts[fieldName] = (fieldCounts[fieldName] || 0) + 1;
          }
          if (STATUS_ID.APPROVED.indexOf(item.document_status_id) >= 0) {
            statusCounts.approved++;
          } else if (STATUS_ID.ONGOING.indexOf(item.document_status_id) >= 0) {
            statusCounts.ongoing++;
          }
        }

        this.totalCount = data.length;
        this.fieldCounts = fieldCounts;
        this.statusCounts = statusCounts;
      } catch (e) {
        console.error("[899 Summary] loadSummary error:", e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.env-impact-summary {
  width: 100%;
  font-size: 16px;
  padding: 12px 0;
}
</style>
